'use strict';exports.__esModule = true;exports.changeBuyMoreQuestionsModalType = exports.hideBuyMoreQuestionsModal = exports.openBuyMoreQuestionsModal = undefined;var _reduxAct = require('redux-act');
var _constants = require('../../constants');



var openBuyMoreQuestionsModal = (0, _reduxAct.createAction)('/OPEN_BUY_MORE_QUESTIONS_MODAL');
var hideBuyMoreQuestionsModal = (0, _reduxAct.createAction)('/HIDE_BUY_MORE_QUESTIONS_MODAL');
var changeBuyMoreQuestionsModalType = (0, _reduxAct.createAction)('/CHANGE_BUY_MORE_QUESTIONS_MODAL_TYPE');

var initialState = {
  isBuyMoreQuestionsModalOpen: false,
  buyMoreQuestionsModalType: _constants.buyMoreQuestionsModalType.QUESTIONS_PRICING };


var handleOpen = function handleOpen(state) {return Object.assign({},
  state, {
    isBuyMoreQuestionsModalOpen: true,
    buyMoreQuestionsModalType: _constants.buyMoreQuestionsModalType.QUESTIONS_PRICING });};


var handleHide = function handleHide(state) {return Object.assign({},
  state, {
    isBuyMoreQuestionsModalOpen: false });};


var handleChangeModalType = function handleChangeModalType(state, action) {return Object.assign({},
  state, {
    buyMoreQuestionsModalType: action.modalType });};


var buyMoreQuestions = (0, _reduxAct.createReducer)(function (on) {
  on(openBuyMoreQuestionsModal, handleOpen);
  on(hideBuyMoreQuestionsModal, handleHide);
  on(changeBuyMoreQuestionsModalType, handleChangeModalType);
}, initialState);exports.


openBuyMoreQuestionsModal = openBuyMoreQuestionsModal;exports.
hideBuyMoreQuestionsModal = hideBuyMoreQuestionsModal;exports.
changeBuyMoreQuestionsModalType = changeBuyMoreQuestionsModalType;exports.default =


buyMoreQuestions;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/buyMoreQuestions.js
// module id = 582
// module chunks = 0